import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getTokenFromLocalStorage = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user).token : null;
};
//console.log(getTokenFromLocalStorage.token);

//axios config
const getAuthConfig = () => {
  const token = getTokenFromLocalStorage();
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
};

const login = async (user) => {
  const response = await axios.post(`${base_url}user/sign-in`, user);
  //console.log(response.data);
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

// //get User orders
// const getUserOrders = async () => {
//   const response = await axios.get(`${base_url}user/get-orders`, config);
//   //console.log(response.data);

//   return response.data;
// };

//get All orders
const getAllOrders = async (paymentStatus) => {
  const response = await axios.get(`${base_url}orders/list?limit=50&status=${paymentStatus}`, getAuthConfig());
  //console.log(response.data);

  return response.data;
};

const authService = {
  login,
  //getUserOrders,
  getAllOrders,
};

export default authService;
